<template>
    <sa-page-layout slot="table-body" :btnBackVisible="true" :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading" :linkback="linkback">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaConfigurazione">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-body">
            <malattie-infettive-configurazione-uosd-list-component ref="cmpMalattieConfigurazioneUosd" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import MalattieInfettiveConfigurazioneUosdListComponent from "../components/MalattieInfettiveConfigurazioneUosdListComponent.vue";
export default {
    components: { SaPageLayout, MalattieInfettiveConfigurazioneUosdListComponent },
    data() {
        return {
            pathResource: "",
            showModalLoading: false,
            linkback: "/home",
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },

    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpMalattieConfigurazioneUosd.loadData();
        },
        onClickNuovaConfigurazione() {
            let me = this;
            me.$refs.cmpMalattieConfigurazioneUosd.onClickNuovoUosd();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onRefresh() {
            let me = this;
            me.$refs.cmpMalattieConfigurazioneUosd.loadData();
        },
    },
};
</script>
